import { OwcWorkflowOverlay } from '@one/react';
import styled from 'styled-components';

export const WorkflowComponent = styled(OwcWorkflowOverlay)`
  /* To impact just in workflow overlay component */
  owc-component-header.sc-owc-workflow-overlay {
    box-shadow: var(--one-elevation-box-shadow-2);
    max-width: 100%;
  }

  &.level1 {
    owc-card.sc-owc-workflow-overlay > div {
      background-color: var(--one-color-background-intensity-lower) !important;
    }

    owc-component-footer {
      background-color: var(--one-color-background-intensity-lower) !important;
    }
  }

  &.level2 {
    /* From instace, inherit styles */
  }

  /* To take just workfloy card */
  owc-card.sc-owc-workflow-overlay > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 1 auto;
    min-height: 0;

    & > div {
      /* UX redesign of workflow content padding */
      padding: 16px !important;
    }

    /* Content wrapper spans full width; scrolling and the width cap live on the
       slotted content (WorkflowContentLayout + WorkflowContentInnerLayout), so
       the scrollbar reaches the screen edge. */
    & > * {
      width: 100%;
    }
  }
`;
